import { cn } from "@verse_core/shared_components/ClassName";

export function Header2XL({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "tw-font-degular tw-text-[36px] tw-font-normal tw-leading-none tw-tracking-[-0.36px] tw-text-blue-dark-1",
        className,
      )}
    >
      {children}
    </div>
  );
}

/** Rebrand page title, e.g. on the login and sign-up cards. An h1, unlike the
 * other headers, because it is the page's title. */
export function HeaderLG({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <h1
      className={cn(
        "tw-m-0 tw-font-sohne tw-text-[24px] tw-font-light tw-leading-[1.4] tw-tracking-[-0.48px] tw-text-verse-text-primary",
        className,
      )}
    >
      {children}
    </h1>
  );
}

export function Header1XL({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "tw-font-degular tw-text-[28px] tw-font-medium tw-not-italic tw-leading-none tw-tracking-[-0.28px] tw-text-blue-dark-1",
        className,
      )}
    >
      {children}
    </div>
  );
}
